import styled from "styled-components";

export const FlexSpaceBetween = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const Overlay = styled.div(({ isOpen }) => ({
  position: "fixed",
  background: "rgba(40, 46, 46, 0.88)",
  width: "100%",
  height: "100vh",
  inset: "0",
  visibility: isOpen ? "visible" : "hidden",
  zIndex: isOpen ? 99999999 : -1,
  transition: "z-index 4s ease-out",
}));

export const SidebarContainer = styled.aside(({ theme, isOpen }) => ({
  position: "fixed",
  maxWidth: "85%",
  width: "328px",
  height: "100%",
  listStyleType: "none",
  margin: "0",
  right: "0",
  top: "0",
  zIndex: isOpen ? 99999999 : -1,
  backgroundColor: theme.color.neutral["08"],
  transform: isOpen ? "translateX(0)" : "translateX(100%)",
  transition: "transform 0.3s ease-in-out, z-index 0.2s ease-in-out",

  "a, ul li": {
    listStyle: "none",
    textDecoration: "none",
  },
}));

export const SidebarHeader = styled.header(({ theme }) => ({
  ...FlexSpaceBetween,
  padding: "20px 16px",
  backgroundColor: theme.color.brandPrimary.medium,
  color: theme.color.neutral["08"],

  div: {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    gap: "10px",
    color: theme.color.neutral["08"],
  },

  svg: {
    width: "28px",
    height: "28px",
    color: theme.color.neutral["08"],
    cursor: "pointer",
  },
}));

export const SidebarLinksList = styled.ul(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  padding: "0px 16px",
  margin: "0 auto",
  paddingLeft: "20px",
  maxWidth: "1132px",
  color: theme.color.brandPrimary.light,

  svg: {
    width: "28px",
    height: "28px",
  },

  div: {
    display: "flex",
    alignItems: "center",
    fontSize: "16px",
    gap: "8px",
  },

  a: {
    ...FlexSpaceBetween,
    borderBottom: `1px solid ${theme.color.neutral["05"]}`,
    paddingTop: "20px",
    paddingBottom: "20px",

    ".column-start": {
      display: "flex",
      alignItems: "flex-start",
      flexDirection: "column",
      fontSize: "16px",
      gap: "0",
    },

    ".column-start span": {
      fontSize: "14px",
    },
  },
}));
